import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const productApi = createApi({
    reducerPath: "productApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        addOwnedProduct: builder.mutation({
            query: (body) => ({
                url: "/Product/add-owned",
                method: "POST",
                body,
            }),
        }),

        addConsignedProduct: builder.mutation({
            query: (body) => ({
                url: "/Product/add-consigned",
                method: "POST",
                body,
            }),
        }),

        addOtherProduct: builder.mutation({
            query: (body) => ({
                url: "/Product/add-other",
                method: "POST",
                body,
            }),
        }),

        addCompany: builder.mutation({
            query: (name) => ({
                url: `/Product/add-company/${encodeURIComponent(name)}`,
                method: "POST",
            }),
        }),

        getAllCompanies: builder.query({
            query: () => ({
                url: "/Product/all-companies",
                method: "GET",
            }),
        }),
 
        deleteCompany: builder.mutation({
            query: (id) => ({
                url: `/Product/delete-company/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useAddOwnedProductMutation,
    useAddConsignedProductMutation,
    useAddOtherProductMutation,
    useAddCompanyMutation,
    useGetAllCompaniesQuery,
    useDeleteCompanyMutation, 
} = productApi;
